module.exports = __webpack_public_path__ + "img/due-today.7de36520.svg";